import { JOBS_PORTAL_PATH } from '../config/paths';

/**
 * Deep link into the Jobs workspace task detail (TaskReviewPage).
 */
export function getNotificationLink(notification) {
    const type = String(notification?.type || '').toLowerCase();
    const taskId = notification?.taskId;

    if (taskId) {
        const params = new URLSearchParams();
        params.set('taskId', String(taskId));

        if (
            type.includes('dispute') ||
            type === 'refund_rejected'
        ) {
            params.set('panel', 'dispute');
        } else if (type.includes('submitted')) {
            params.delete('panel');
        }

        return `${JOBS_PORTAL_PATH}?${params.toString()}`;
    }

    if (type.includes('dispute')) {
        return '/dispute';
    }

    return '/dashboard';
}

/** Prefer the newest unread notification that points at a task. */
export function getFirstUnreadTaskNotificationLink(notifications = []) {
    const row = notifications.find(
        (n) => !n.readStatus && n.taskId != null && n.taskId !== '',
    );
    if (row) return getNotificationLink(row);
    return `${JOBS_PORTAL_PATH}?section=workspace&panel=tasks`;
}

export function getNotificationIcon(notificationOrType) {
    const t =
        typeof notificationOrType === 'object' && notificationOrType !== null
            ? `${notificationOrType.type || ''} ${notificationOrType.title || ''} ${notificationOrType.body || ''}`.toLowerCase()
            : String(notificationOrType || '').toLowerCase();
    if (t.includes('rework') || t.includes('resubmit')) return 'fa-solid fa-rotate';
    if (t.includes('assigned')) return 'fa-solid fa-briefcase';
    if (t.includes('submitted')) return 'fa-solid fa-paper-plane';
    if (t.includes('approved')) return 'fa-solid fa-circle-check';
    if (t.includes('rejected')) return 'fa-solid fa-circle-xmark';
    if (t.includes('accepted')) return 'fa-solid fa-handshake';
    if (t.includes('refund')) return 'fa-solid fa-rotate-left';
    if (t.includes('dispute')) return 'fa-solid fa-flag';
    return 'fa-solid fa-bell';
}

export function formatNotificationTime(createdAt) {
    if (!createdAt) return '';
    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) return '';
    const now = Date.now();
    const diffMs = now - date.getTime();
    const mins = Math.floor(diffMs / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}d ago`;
    return date.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
    });
}
